<app-header></app-header>
<div id="main-content" [hidden]="caseViewIsVisible">
    <router-outlet></router-outlet>
</div>
<router-outlet name="view"></router-outlet>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/app.component.html